import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Admin_Parivartan_Branch_Update, Admin_Parivartan_Delete_Branch, Admin_Region_Name } from "../../../../constants";
import axios from "axios";

const RoBoTableComponent = ({ roBoList, loading, setLoading, onRefresh }) => {
const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Slice data for current page
  const paginatedRows = roBoList.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [branchName, setBranchName] = useState("");
  const [selectedBranchId, setSelectedBranchId] = useState("");

  const handleDeleteCategory = async () => {
    if (!selectedBranchId) return;

    try {
      setLoading(true);
      const response = await axios.delete(
        `${Admin_Parivartan_Delete_Branch}/${selectedBranchId}`
      );

      if (response.status === 200) {
        console.log("Branch deleted successfully");
        setDeleteModalOpen(false);
        onRefresh();
      } else {
        console.error("Failed to delete branch");
      }
    } catch (error) {
      console.error("Error deleting branch:", error);
    } finally {
      setLoading(false);
    }
  };

  // Update state
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [updateData, setUpdateData] = useState({
    Branch: "",
    RegionId: "",
  });

  const [regionList, setRegionList] = useState([]);

  const fetchRegion = async () => {
    try {
      const response = await axios.get(`${Admin_Region_Name}`);
      setRegionList(response.data.data || []);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    }
  };

  useEffect(()=>{
    fetchRegion();
  },[updateModalOpen]);


  // Update API
  const handleUpdateBranch = async () => {
    if (!selectedBranchId) return;

    try {
      setLoading(true);
      const response = await axios.put(
        `${Admin_Parivartan_Branch_Update}/${selectedBranchId}`,
        updateData
      );
      
      if (response.data.success) {
        console.log("Branch updated successfully");
        setUpdateModalOpen(false);
        onRefresh();
      }
    } catch (error) {
      console.error("Error updating branch:", error);
    } finally {
      setLoading(false);
    }
  };



  if (loading) {
    return (
      // <div>Loading region assignments...</div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight={120}
      >
        <CircularProgress size={24} sx={{ mr: 2 }} />
        <Typography>Loading RO/BO List...</Typography>
      </Box>
    );
  }

  if (!roBoList || roBoList.length === 0) {
    return (
      // <div>No region assignments found.</div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight={120}
      >
        <Typography>No RO/BO found.</Typography>
      </Box>
    );
  }

  return (
    <>
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <Box p={0}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "grey.100" }}>
                  <TableCell sx={{ fontWeight: 600 }}>S No.</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Branch Code</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Region ID</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Zone</TableCell>
                  <TableCell sx={{ fontWeight: 600 }} width={50}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {roBoList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 6 }}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        gap={1}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={48}
                          height={48}
                          fill="none"
                          viewBox="0 0 24 24"
                          style={{ color: "#bdbdbd", marginBottom: 8 }}
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                          />
                        </svg>
                        <Typography color="text.secondary">
                          No RO/BO found
                        </Typography>
                        <Typography variant="body2" color="text.disabled">
                          Try adjusting your search or filters
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedRows.map((ro, index) => (
                    <TableRow key={ro.id}>
                      <TableCell>
                        <Typography variant="body2">{index + 1}.</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {ro.BranchCode || "-"}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography variant="body2" fontWeight="500">
                          {ro.Branch || "-"}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography variant="body2" fontWeight="500">
                          {ro.RegionId || "-"}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography variant="body2">
                          {ro.Zone || "-"}
                        </Typography>
                      </TableCell>

                      <TableCell width={50}>
                      <Button
                        size="small"
                        variant="outlined"
                        color="secondary"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedBranchId(ro.id);
                          setUpdateData({
                            Branch: ro.Branch,
                            RegionId: ro.RegionId,
                          });
                          setUpdateModalOpen(true);
                        }}
                      >
                        Update
                      </Button>

                        <Button
                          size="small"
                          variant="outlined"
                          color="warning"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedBranchId(ro.id);
                            setBranchName(ro.Branch);
                            setDeleteModalOpen(true);
                          }}
                          sx={{mt: 1}}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* Pagination */}
          {roBoList.length > 0 && (
            <TablePagination
              component="div"
              count={roBoList.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          )}
        </Box>
      </Paper>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Delete Branch</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete the branch{" "}
            <Box component="span" fontWeight="bold" display="inline">
              {branchName}
            </Box>
            ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteModalOpen(false)}
            disabled={loading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteCategory}
            color="error"
            disabled={loading}
            variant="contained"
          >
            {loading ? (
              <>
                <CircularProgress size={18} sx={{ mr: 1 }} />
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update Modal */}
      <Dialog
        open={updateModalOpen}
        onClose={() => setUpdateModalOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Update Branch</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2} mt={1}>
            <TextField
              label="Branch Name"
              fullWidth
              value={updateData.Branch}
              onChange={(e) =>
                setUpdateData({ ...updateData, Branch: e.target.value })
              }
            />
           <FormControl fullWidth>
              <InputLabel id="branch-label">Region Name</InputLabel>
              <Select
                labelId="branch-label"
                label="Region Name"
                value={updateData.RegionId}
                onChange={(e) =>{ 
                  setUpdateData({ ...updateData, RegionId: e.target.value })
                }}
                size="small"
              >
                <MenuItem value="">
                  <em>Select Region</em>
                </MenuItem>
                {regionList.map((st) => (
                  <MenuItem key={st.RegionId} value={st.RegionId}>
                    {st.RegionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setUpdateModalOpen(false)}
            disabled={loading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdateBranch}
            color="primary"
            disabled={loading}
            variant="contained"
          >
            {loading ? (
              <>
                <CircularProgress size={18} sx={{ mr: 1 }} />
                Updating...
              </>
            ) : (
              "Update"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RoBoTableComponent;
